var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 0C0.783502 0 0 0.783502 0 1.75V5.25C0 6.2165 0.783501 7 1.75 7H20.25C21.2165 7 22 6.2165 22 5.25V1.75C22 0.783502 21.2165 0 20.25 0H1.75ZM20.25 1.5H1.75C1.61193 1.5 1.5 1.61193 1.5 1.75V5.25C1.5 5.38807 1.61193 5.5 1.75 5.5H20.25C20.3881 5.5 20.5 5.38807 20.5 5.25V1.75C20.5 1.61193 20.3881 1.5 20.25 1.5Z",
    fill: "#24292E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 8C2.16421 8 2.5 8.33579 2.5 8.75V18.25C2.5 18.3881 2.61193 18.5 2.75 18.5H19.25C19.3881 18.5 19.5 18.3881 19.5 18.25V8.75C19.5 8.33579 19.8358 8 20.25 8C20.6642 8 21 8.33579 21 8.75V18.25C21 19.2165 20.2165 20 19.25 20H2.75C1.7835 20 1 19.2165 1 18.25V8.75C1 8.33579 1.33579 8 1.75 8Z",
    fill: "#24292E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 9.5C8.33579 9.5 8 9.83579 8 10.25C8 10.6642 8.33579 11 8.75 11H13.25C13.6642 11 14 10.6642 14 10.25C14 9.83579 13.6642 9.5 13.25 9.5H8.75Z",
    fill: "#24292E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive-icon.1e125582.svg";
export { ForwardRef as ReactComponent };